import { useCallback, useContext, useEffect, useState } from "react";
import { IsTeacher } from "../../../components/exl/CourseHelperFunctions";
import { GetLectureById } from "../../../components/exl/requests/LectureRequests";
import { DataContext } from "../../../store";
import { DataContext as SharedDataContext } from "../../../stores/crm-store";
import {navigate} from "hookrouter";

const getLectureData = async (id, updateLoadingState, updateLectureState, dispatch) => {
  updateLoadingState(true);
    const lectureResponse = await GetLectureById(id);
    if (lectureResponse === null) {
        navigate("/exlCourses");
        dispatch({ type: "SHOW_ERROR_TOAST" });
    }
  updateLectureState(lectureResponse);
  updateLoadingState(false);
};

const getLectureUser = (user, updateLectureUserState, lecture) => {
  let booking = null;
  if (lecture.course?.bookings !== null) {
    booking = lecture.course?.bookings.find((b) =>
    b.coaEmpId.toUpperCase() === user.id.toUpperCase());
  }
  const isTeacher = IsTeacher(lecture, user);
  const isAdmin = user.isAdmin;
  const isExlAdmin = user.isExlAdmin;
  const isNormalUser = user.isExlUser;
  const id = user.id;

  updateLectureUserState({
    isRegistered: !!booking,
    teacherPermission: isTeacher,
    editPermission: isExlAdmin,
    normalUserPermission: isNormalUser,
    booking: booking,
    coaEmpId: id,
  });
}


export default function useLectureDetails(lectureId) {
  const [lecture, setLecture] = useState(null);
  const [loading, setLoading] = useState(false);
  const [lectureUser, setLectureUser] = useState(null);

  const { dispatch: sharedDispatch } = useContext(SharedDataContext);

  const {
    store: { user },
  } = useContext(DataContext);

  useEffect(() => {
    if (!lecture || lecture?.id !== lectureId)
      getLectureData(lectureId, setLoading, setLecture, sharedDispatch);

    if (user && lecture) 
      getLectureUser(user, setLectureUser, lecture);

  }, [lectureId, user, lecture]);

  const refreshLectureData = () => {
    getLectureData(lectureId, setLoading, setLecture, sharedDispatch);
  }

  return {
    lecture,
    loading,
    lectureUser,
    refreshLectureData
  }
}